import { render, staticRenderFns } from "./VStats.vue?vue&type=template&id=11b3e92f&"
import script from "./VStats.vue?vue&type=script&lang=js&"
export * from "./VStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports